import React from 'react'
import { useFormContext, Controller } from 'react-hook-form'

import 'react-phone-input-2/lib/material.css'
import { Grid, MenuItem, FormControl, Select, InputLabel } from '@material-ui/core'

import { fetaures } from '~/constants/data-field'
import { useGrowCropsStore } from '~/store/variety/growcrops'

import { useStyles } from './style'

export const IllnessForms: React.FC = () => {
  const classes = useStyles()
  const { control } = useFormContext<any>()

  const featuresList = useGrowCropsStore((state) => state.featuresList)

  const arrayFeatures = featuresList.filter((item) => {
    return item?.tipo === 'DOENCAS'
  })

  return (
    <Grid container spacing={3} className={classes.modalStyle}>
      {arrayFeatures?.map((item) => (
        <Grid item sm={6} key={item.id}>
          <Controller
            name={item.caracteristica
              .replace(/\s/g, '')
              .replace('-', '')
              .replace('-', '')
              .replace('-', '')
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
              .toLowerCase()}
            control={control}
            render={({ field }) => (
              <FormControl variant="outlined" className={classes.selectInput}>
                <InputLabel id={`${item.caracteristica.replace(/\s/g, '')}_id`}>
                  {item.caracteristica}
                </InputLabel>
                <Select
                  {...field}
                  labelId={`${item.caracteristica.replace(/\s/g, '')}_id`}
                  id={item.caracteristica
                    .replace(/\s/g, '')
                    .replace('-', '')
                    .replace('-', '')
                    .replace('-', '')
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '')
                    .toLowerCase()}
                  label={item.caracteristica}
                  autoWidth
                  required
                  defaultValue=""
                >
                  {fetaures.map((Option) => (
                    <MenuItem key={Option.fetauresValue} value={Option.fetauresValue}>
                      {Option.fetauresName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          />
        </Grid>
      ))}
    </Grid>
  )
}
